import {
    customerInfoProviderToken,
    localizationInfoProviderToken,
} from "@/tokens";
import { WishlistsQuery } from "@apps/wishlist/queries/WishlistsQuery";
import { WishlistsService } from "@apps/wishlist/services/WishlistsService";
import { CustomerInfoProviderInterface } from "@lib/CustomerInfoProvider/CustomerInfoProviderInterface";
import { LocalizationInfoProviderInterface } from "@lib/LocalizationInfoProvider/LocalizationInfoProviderInterface";
import { Observable, map, switchMap, take } from "rxjs";
import { container } from "tsyringe";

import { WishlistItemSdkDto, WishlistSdkDto } from "../types";
import { mapWishlistItemToSdkDto } from "../utils/mapWishlistItemToSdkDto";
import { mapWishlistToSdkDto } from "../utils/mapWishlistToSdkDto";

export class WishlistsStateKitServiceWrapper {
    private localizationInfoProvider: LocalizationInfoProviderInterface;
    private customerInfoProvider: CustomerInfoProviderInterface;

    constructor(
        private readonly wishlistsService: WishlistsService,
        private readonly wishlistsQuery: WishlistsQuery
    ) {
        this.localizationInfoProvider = container.resolve(
            localizationInfoProviderToken
        );

        this.customerInfoProvider = container.resolve(
            customerInfoProviderToken
        );
    }

    getWishlists(): Observable<WishlistSdkDto[]> {
        const locale = this.localizationInfoProvider.getGwI18nLocale();
        const companyId = this.customerInfoProvider.getCompany()?.id;

        return this.wishlistsService.getWishlists({ locale, companyId }).pipe(
            switchMap(() => this.wishlistsQuery.selectAll()),
            take(1),
            map((wishlists) => wishlists.map(mapWishlistToSdkDto))
        );
    }

    addItem(params: {
        productId: number;
        variantId: number;
        wishlistId: number | null;
    }): Observable<WishlistItemSdkDto> {
        return this.wishlistsService
            .addItem(params)
            .pipe(map(mapWishlistItemToSdkDto));
    }

    deleteItem(params: {
        productId: number;
        wishlistId?: number;
        variantId?: number;
    }): Observable<WishlistItemSdkDto> {
        return this.wishlistsService
            .deleteItem(params)
            .pipe(map(mapWishlistItemToSdkDto));
    }
}
